/* TODO Clean up this file after testing.  This was a copy of quiz-question. */
import { observable } from "mobx";

import { QuizObject } from "./quiz-object";

class HistoryItem {
    @observable correct: boolean = true;
    @observable updatedAt: Date = new Date();
    @observable createdAt: Date = new Date();

    constructor(historyItem: any) {
        this.correct = historyItem.correct;
        this.updatedAt = historyItem.updatedAt;
        this.createdAt = historyItem.updatedAt;
    }
}

class QuizQuestionAnswer {
    @observable id: string = "";
    // @observable type: string;
    // @observable slug: string;
    // @observable optionalContext: string;
    @observable text: string = "";
    // @observable value: string;
    @observable show_answer: boolean = false;
    @observable isCorrect: boolean = false;
    @observable correctAnswer: string = "";
    @observable givenAnswer: string = ""
    // @observable choices: Array<string>;
    // @observable quiz_object: QuizObject;
    // @observable object_id: string;
    // @observable formula: any;
    @observable history: Array<HistoryItem> = [];

    constructor(quiz_question_answer: any) {
        this.id = quiz_question_answer.id;

        if (quiz_question_answer.history) {
            this.history = quiz_question_answer.history.map((hi: any) => {
                return new HistoryItem(hi);
            });    
        }

        this.correctAnswer = quiz_question_answer.correctAnswer;
        this.givenAnswer = quiz_question_answer.givenAnswer;
        this.isCorrect = quiz_question_answer.isCorrect;
        // this.choices = quiz_question_answer.choices;
        // this.type = quiz_question_answer.type;
        this.text = quiz_question_answer.text;
        // this.optionalContext = quiz_question_answer.optionalContext;
        // this.slug = quiz_question_answer.slug;
        // this.formula = quiz_question_answer.formula;
        this.show_answer = quiz_question_answer.show_answer;
        // this.quiz_object = quiz_question_answer.quiz_object;
        // this.object_id = quiz_question_answer.object_id;
    }

    historyCompare(a: any, b: any): number {
            let aTime = new Date(a.createdAt).getTime();
            let bTime = new Date(b.createdAt).getTime();
            return bTime - aTime
    }

    sortedHistory(): Array<HistoryItem> {
        return this.history.sort(this.historyCompare)
    }

    historyResults(): Array<any> {
        const sortedHistory = this.sortedHistory();

        return sortedHistory
            .map((hi: HistoryItem) => {
                return {
                    correct: hi.correct,
                    createdAt: hi.createdAt
                };
            }).slice(0,9);
    }
}

export { QuizQuestionAnswer };
